<template>
  <div class="md-layout md-size-65 menu-selector">
    <div class="menu-group-mobile">
      <div class="md-layout-item md-size-12 md-small-size-25 row-buttons">
        <drop-down direction="down">
            <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
            {{regionSelected.one}}
            </md-button>
            <ul class="dropdown-menu dropdown-menu-right">
            <li v-for="region in regions" :key="region"><a @click="changeSelectedRegion(1, region)">{{region}}</a></li>
            </ul>
        </drop-down>
      </div>
      <div class="md-layout-item md-size-12 md-small-size-25 row-buttons">
        <drop-down direction="down">
            <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
            {{cropSelected.one}}
            </md-button>
            <ul class="dropdown-menu dropdown-menu-right">
            <li v-for="crop in crops" :key="crop"><a @click="changeSelectedCrop(1, crop)">{{crop}}</a></li>
            </ul>
        </drop-down>
      </div>
    </div>
    <div class="menu-group-mobile">
      <div class="md-layout-item md-size-12 md-small-size-25 row-buttons md-xsmall-size-50">
        <drop-down direction="down">
            <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
            {{regionSelected.two}}
            </md-button>
            <ul class="dropdown-menu dropdown-menu-right">
            <li><a @click="changeSelectedRegion(2, 'Region')">Region</a></li>
            <li v-for="region in regions" :key="region"><a @click="changeSelectedRegion(2, region)">{{region}}</a></li>
            </ul>
        </drop-down>
      </div>
      <div class="md-layout-item md-size-12 md-small-size-25 row-buttons md-xsmall-size-50">
        <drop-down direction="down">
            <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
            {{cropSelected.two}}
            </md-button>
            <ul class="dropdown-menu dropdown-menu-right">
            <li><a @click="changeSelectedCrop(2, 'Cultivo')">Cultivo</a></li>
            <li v-for="crop in crops" :key="crop"><a @click="changeSelectedCrop(2, crop)">{{crop}}</a></li>
            </ul>
        </drop-down>
      </div>
    </div>
    <div class="md-layout-item md-size-12 row-buttons hide-960">
      <drop-down direction="down">
          <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
          {{regionSelected.three}}
          </md-button>
          <ul class="dropdown-menu dropdown-menu-right">
          <li><a @click="changeSelectedRegion(3, 'region')">Region</a></li>
          <li v-for="region in regions" :key="region"><a @click="changeSelectedRegion(3, region)">{{region}}</a></li>
          </ul>
      </drop-down>
    </div>
    <div class="md-layout-item md-size-12 row-buttons hide-960">
        <drop-down direction="down">
            <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
            {{cropSelected.three}}
            </md-button>
            <ul class="dropdown-menu dropdown-menu-right">
            <li><a @click="changeSelectedCrop(3, 'Cultivo')">Cultivo</a></li>
            <li v-for="crop in crops" :key="crop"><a @click="changeSelectedCrop(3, crop)">{{crop}}</a></li>
            </ul>
        </drop-down>
    </div>
    <div class="md-layout-item md-size-12 row-buttons hide-960">
        <drop-down direction="down">
            <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
            {{regionSelected.four}}
            </md-button>
            <ul class="dropdown-menu dropdown-menu-right">
            <li><a @click="changeSelectedRegion(4, 'region')">Region</a></li>
            <li v-for="region in regions" :key="region"><a @click="changeSelectedRegion(4, region)">{{region}}</a></li>
            </ul>
        </drop-down>
    </div>
    <div class="md-layout-item md-size-12 row-buttons hide-960">
        <drop-down direction="down">
        <md-button slot="title" class="md-button md-success md-sm md-block dropdown-toggle" data-toggle="dropdown">
            {{cropSelected.four}}
        </md-button>
        <ul class="dropdown-menu dropdown-menu-right">
            <li><a @click="changeSelectedCrop(4, 'Cultivo')">Cultivo</a></li>
            <li v-for="crop in crops" :key="crop"><a @click="changeSelectedCrop(4, crop)">{{crop}}</a></li>
        </ul>
        </drop-down>
    </div>
  </div>
</template>

<script>

export default {
  name: 'menu-selector',
  props: ['regions', 'crops'],
  data() {
    return {
      val: this.value,
      regionSelected: {
        one: '',
        two: '',
        three: '',
        four: ''
      },
      cropSelected: {
        one: '',
        two: '',
        three: '',
        four: ''
      },
    }
  },
  mounted() {
    this.initData();
    this.$emit('set-regions', this.regionSelected);
    this.$emit('set-crops', this.cropSelected)
  },
  methods: {
    changeSelectedRegion(column, option) {
      switch(column) {
      case 1: this.regionSelected.one = option; break;
      case 2: this.regionSelected.two = option; break;
      case 3: this.regionSelected.three = option; break;
      case 4: this.regionSelected.four = option; break;
      }
      this.$emit('crop-or-region',column);
    },
    changeSelectedCrop(column, option) {
      switch(column) {
      case 1: this.cropSelected.one = option; break;
      case 2: this.cropSelected.two = option; break;
      case 3: this.cropSelected.three = option; break;
      case 4: this.cropSelected.four = option; break;
      }
      this.$emit('crop-or-region',column);
    },
    initData() {
      this.regionSelected.one = this.regions[0];
      this.regionSelected.two = 'Region';
      this.regionSelected.three = 'Region';
      this.regionSelected.four = 'Region';
      this.cropSelected.one = this.crops[0];
      this.cropSelected.two = 'Cultivo';
      this.cropSelected.three = 'Cultivo';
      this.cropSelected.four = 'Cultivo';
    },
  }
}
</script>

<style>
.md-size-12{
  max-width: 12.5%;
  min-width: 12.5%;
}
.row-buttons{
  padding-right: 2px;
  padding-left: 2px;
}
.menu-group-mobile{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-width: 25%;
  max-width: 25%;
}
.menu-group-mobile .md-layout-item{
  min-width: 50%;
}
@media only screen and (max-width: 960px) {
  .hide-960{
    display: none
  }
}
@media only screen and (max-width: 600px) {
  .menu-group-mobile{
    flex-direction: column;
  }
  .menu-selector{
    flex-wrap: nowrap;
    width: 50%;
  }
  .menu-group-mobile{
    min-width: 50%;
    max-width: 50%;
  }
  .menu-group-mobile .md-layout-item{
    min-width: 95px !important;
  }
  .menu-group-mobile .md-button-content{
    font-size: 10px;
  }
}
</style>

